"use client";

import Script from "next/script";
import React from "react";
import { GTM_CONTAINER_ID, KLAVIYO_PUBLIC_API_KEY } from "constants/site";
import { useUserContext } from "hooks";

// Extend the Window interface to include Klaviyo
type KlaviyoWindow = Window & {
  klaviyo?: {
    push: (args: [string, Record<string, unknown>]) => void;
  };
};

const Scripts: React.FC = () => {
  const { currentUser } = useUserContext();

  return (
    <>
      {/* GTM */}
      {GTM_CONTAINER_ID && (
        <>
          <Script
            id="gtm-loader"
            src={`https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`}
            strategy="afterInteractive"
          />
          <Script id="gtm-init" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
              });
            `}
          </Script>
        </>
      )}

      {/* Klaviyo */}
      {KLAVIYO_PUBLIC_API_KEY && (
        <Script
          src={`//static.klaviyo.com/onsite/js/klaviyo.js?company_id=${KLAVIYO_PUBLIC_API_KEY}`}
          strategy="afterInteractive"
          onLoad={() => {
            if (currentUser) {
              const win = window as KlaviyoWindow;
              const intervalId = setInterval(() => {
                if (win.klaviyo) {
                  win.klaviyo.push([
                    "identify",
                    {
                      $email: currentUser.email,
                      $first_name: currentUser.firstName,
                      $last_name: currentUser.lastName,
                      LicenceTypes: currentUser.userFields?.licenseData?.map(ld => ld?.type),
                      City: currentUser.userFields?.city,
                      State: currentUser.userFields?.state,
                      ZIP: currentUser.userFields?.zip,
                    },
                  ]);
                  clearInterval(intervalId);
                }
              }, 200);
            }
          }}
        />
      )}
    </>
  );
};

export default Scripts;
